import Navbar from "@/src/lib/components/app/Navbar";
import Sidebar from "@/src/lib/components/app/Sidebar";
import { SplashScreen } from "@/src/lib/components/ui/splash-screen";
import Footer from "./home/components/Footer";

export default function Layout({ children }: { children: React.ReactNode }) {
	return (
		<div className="bg-background [--navbar-height:5rem] sm:[--sidebar-width:5rem]">
			<div className="h-(--navbar-height)">
				<Navbar />
			</div>

			<Sidebar />

			<div className="ml-(--sidebar-width) h-[calc(100dvh-var(--navbar-height))] @container/main">
				{children}
				<Footer />
			</div>

			<SplashScreen />
		</div>
	);
}
